export default (node: HTMLElement) => {
  node.attachShadow({ mode: "open" });
};
